import {BrickContext, Brick, registerBrick } from 'olympe';
import Showdown from 'showdown';

export default class MarkdownToHTML extends Brick {

    /**
     * @override
     * @protected
     * @param {!BrickContext} $
     * @param {string} markdown
     * @param {function(string)} setHtml
     */
    update($, [markdown], [setHtml]) {
        const converter = new Showdown.Converter();
        setHtml(converter.makeHtml(markdown));
    }
}

registerBrick('0191a8dbbb882d896a26', MarkdownToHTML);
